"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const MoveArrowUp = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M10.0711 17.8922C9.65686 17.8922 9.32108 17.5564 9.32108 17.1422L9.32108 4.81068L4.69276 9.439C4.39986 9.7319 3.92499 9.7319 3.6321 9.439C3.3392 9.14611 3.3392 8.67124 3.6321 8.37834L9.54075 2.46969C9.83364 2.1768 10.3085 2.1768 10.6014 2.46969L16.5101 8.37834C16.8029 8.67124 16.8029 9.14611 16.5101 9.439C16.2172 9.7319 15.7423 9.7319 15.4494 9.439L10.8211 4.81068L10.8211 17.1422C10.8211 17.5564 10.4853 17.8922 10.0711 17.8922Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }) })));
};
MoveArrowUp.displayName = 'MoveArrowUp';
exports.default = MoveArrowUp;
